import { expertWorkspaceWebSocketEventBus } from "@expert/websocket";
import { useEffect } from "react";

import { useChatStore } from "@/sdk";
import { useLogger } from "@/sdk/logging/LoggerProvider";
import { userCache } from "@/shared-utils";

export interface ChatCloseEventPayload {
    chatId: string;
    expertEmployeeId: string;
    closeReason: string;
}

export const useChatCloseEventListener = () => {
    const logger = useLogger({
        module: "useChatCloseEventListener",
        supportTeam: "messaging",
    });

    useEffect(() => {
        return expertWorkspaceWebSocketEventBus.on("ws_chat-close-event", (payload: ChatCloseEventPayload) => {
            logger.info({ chatCloseEventPayload: JSON.stringify(payload) }, "Chat close event received");

            const { chatId, expertEmployeeId, closeReason } = payload;
            if (expertEmployeeId !== userCache.employeeId) {
                logger.info(
                    { expertEmployeeId, userCacheEmployeeId: userCache.employeeId },
                    "Ignoring chat close event for different expert",
                );
                return;
            }

            useChatStore.getState().updateCloseReason(chatId, closeReason);
        });
    }, [logger]);
};
